<template slot-scope="props">
    <div class="adiantamento">
        <b-table
            :data="adiantamentos"
            class="data-table"
            hoverable
            responsive
            mobile-cards
            :checkable="idacerto==0"
            :checked-rows.sync="adiantamentosSelecionados"
        >
            <b-table-column
                v-for="f in fields"
                :key="f.key + '-' + f.nome"
                :field="f.key"
                :label="$t(f.key)"
                :width="f.width"
                :sortable="f.sortable"
                v-slot="props"
            >
                <span v-if="f.key == 'data'">
                    {{ props.row.datahorainc | moment("L LT") }}
                </span>

                <div v-else-if="f.key == 'empresa'">
                    <div v-if="!props.row.empresa">-</div>
                    <div v-else>
                        {{ props.row.empresa.nome }}
                    </div>
                </div>

                <span v-else-if="f.key == 'valor'">
                    {{ getDecimal(props.row.valor, null, true) }}
                </span>
            </b-table-column>
            <template slot="bottom-left">
                <div class="columns">
                    <th id="footer-1" class="column is-12">
                        <span> {{ $t("registro") }}: {{ adiantamentos.length }} </span>
                    </th>
                    <th id="footer-2" class="column is-12">
                        <span>
                            {{ $t("valor") }}
                            {{ getDecimal(valorTotalAdiantamentos, null, true) }}
                        </span>
                    </th>
                </div>
            </template>
        </b-table>
    </div>
</template>
<script>
import AdiantamentoService from "@/services/despesas/AdiantamentoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
    },
    props: {
        adiantamentos: {
            type: Array,
            default: () => [],
        },
        empresasInner: {
            type: Array,
            default: () => [],
        },
        valorTotalAdiantamentos: 0,
        idacerto: 0
    },
    data() {
        return {
            fields: [
                { key: "data", label: "Data", width: "16rem", sortable: false },
                { key: "empresa", width: 165, sortable: false, footer: false },
                { key: "valor", label: "Valor", width: "96rem", sortable: false },
            ],
            pagination: {
                perPageOptions: [10, 25, 50, 100],
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            service: new AdiantamentoService(this.$http, this.$router),
            isLoading: false,
            adiantamentosSelecionados: [],
            totalAcerto: 0,
        };
    },
    watch: {
        adiantamentos(val){
            if(val.length){
                this.adiantamentosSelecionados = Object.assign([], val);
            }
        },
        adiantamentosSelecionados: {
            deep: true,
            handler() {
                this.$emit("adiantamentos-selecionados", this.adiantamentosSelecionados);
            },
        },
        empresasInner: {
            deep: true,
            handler() {
                this.selecionaAdiantamentos();
            },
        },
    },
    methods: {
        selecionaAdiantamentos() {
            this.adiantamentosSelecionados = [];
            if (this.empresasInner == 0) {
                this.adiantamentos.forEach((adiantamento) => {
                    this.adiantamentosSelecionados.push(adiantamento);
                });
            } else {
                this.adiantamentos.forEach((adiantamento) => {
                    this.empresasInner.forEach((empresa) => {
                        if (adiantamento.empresa.idempresa == empresa.idempresa) {
                            this.adiantamentosSelecionados.push(adiantamento);
                        }
                    });
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.margin-none {
    margin: 0 !important;
}

.lps-table {
    padding-top: 0px;
    font-size: 14px;
}

.check-box {
    transform: scale(1.5);
}
.checkmark {
    position: inherit;
    display: inline-flex;
    top: 0;
    right: 0;
    height: 16px;
    width: 16px;
    border: 2px solid $primary-color-hover;
    margin-top: 2px;
    border-radius: 3px;
}

.center-checkbox {
    vertical-align: middle;
    text-align: center;
}

.b-checkbox {
    transform: scale(1.2);
}

.data-table {
    margin-bottom: 10rem !important;
}

.adiantamento {
    height: 100%;
}
</style>